import { makeStyles } from '@material-ui/core';
import { manewcoTokens, useManewcoTokens } from '@platform/plugin-platform-react';

const useStyles = makeStyles(theme => {
  const MANEWCO = manewcoTokens(theme);
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 28,
      height: 28,
      borderRadius: MANEWCO.radius,
      border: `1px solid ${MANEWCO.line}`,
      fontFamily: MANEWCO.fontFamily,
      fontWeight: 800,
      fontSize: 15,
    },
  };
});

/** Monogramme du menu replié. */
export const LogoIcon = () => {
  const classes = useStyles();
  const MANEWCO = useManewcoTokens();
  return (
    <span className={classes.root} style={{ backgroundColor: MANEWCO.pale, color: MANEWCO.primary }}>
      m
    </span>
  );
};
